import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CountUp from "react-countup";
import { isEmpty } from "lodash";

import ProjectService from "../../services/projectService";

import "./ProjectMetrics.scss";

const ProjectMetrics = ({ project, pm }) => {
  const [budgetConsumed, setBudgetConsumed] = useState(null);

  useEffect(() => {
    const getBudgetConsumed = async () => {
      const amount = await ProjectService.getBudgetConsumed(project._id);
      setBudgetConsumed(amount[0] ? amount[0] : 0);
    };
    if (!isEmpty(project) && project._id) {
      getBudgetConsumed();
    }
  }, [project]);

  const actualHours = (budgetConsumed && budgetConsumed.totalHours) || 0;
  const billableHours =
    (budgetConsumed && budgetConsumed.totalBillableHours) || 0;

  let yieldAmt;
  if (
    project.call_type &&
    (project.call_type.label === "BILLABLE" ||
      project.call_type.label === "PREPAID")
  ) {
    yieldAmt =
      actualHours !== 0 ? (billableHours / actualHours) * project.rate : 0;
  } else yieldAmt = actualHours !== 0 ? project.budget_amount / actualHours : 0; // Budget Over Consumed

  const metrics = [
    { label: "Budget Hours", end: project.budget_hours, suffix: " hrs" },
    {
      label: "Actual / Billable",
      end: actualHours,
      end2: billableHours,
      suffix: " hrs"
    },
    {
      label: "Remaining Billable Hours",
      end: project.budget_hours - billableHours,
      suffix: " hrs"
    },
    { label: "Budget Amount", end: project.budget_amount, prefix: "$ " },
    { label: "Current Yield", end: yieldAmt, prefix: "$ " }
  ];
  if (pm && pm.projectedYield) {
    metrics.splice(-1, 0, {
      label: "Projected Yield",
      end: pm.projectedYield,
      prefix: "$ "
    });
  }
  return !isEmpty(project) ? (
    <div
      className="project-metrics"
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${metrics.length <= 5 ? 5 : 3}, 1fr)`
      }}
    >
      {metrics.map((data, idx) => (
        <div key={idx} className="content-wrapper">
          <fieldset>
            <legend>{data.label}</legend>
          </fieldset>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center"
            }}
          >
            <CountUp
              className="counter"
              suffix={data.suffix}
              prefix={data.prefix}
              decimals={2}
              separator=","
              end={data.end}
            />
            {data.end2 ? (
              <div>
                <span>/</span>
                <CountUp
                  className="counter"
                  suffix={data.suffix}
                  prefix={data.prefix}
                  decimals={2}
                  separator=","
                  end={data.end2}
                />
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  ) : null;
};

ProjectMetrics.propTypes = {
  project: PropTypes.object,
  pm: PropTypes.object
};

export default ProjectMetrics;
